<template>
  <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 20H15C16.1046 20 17 19.1046 17 18V14.2083V8.05823C17 8.03879 16.9997 8.01938 16.9992 8H11H10V7V2H4C2.89543 2 2 2.89543 2 4V11V18C2 19.1046 2.89543 20 4 20ZM12 2.27114V6H15.7786L12.4179 2.59506C12.2924 2.46794 12.1517 2.35938 12 2.27114ZM4 0C1.79086 0 0 1.79086 0 4V11V18C0 20.2091 1.79086 22 4 22H15C17.2091 22 19 20.2091 19 18V14.2083V8.05823C19 7.00642 18.5857 5.99693 17.8469 5.24835L13.8413 1.19012C13.0897 0.428637 12.0644 0 10.9945 0H4Z"
      fill="#708496"
    />
  </svg>
</template>
